<template>
  <div class="backMoneyMain">
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <div slot="header">
        <div class="headerTitle">
          订单信息
        </div>
      </div>
      <div>
        <nut-cell title="订单编号" :desc="orderDetails.ordernumber"></nut-cell>
        <nut-cell title="用户名" :desc="orderDetails.userName"></nut-cell>
        <nut-cell title="订单类型" :desc="orderDetails.orderType"></nut-cell>
        <nut-cell
          title="充电时长"
          :desc="`${orderDetails.hour}小时`"
        ></nut-cell>
        <nut-cell title="充电桩编号" :desc="orderDetails.parkId"></nut-cell>
        <nut-cell title="消费金额" :desc="orderDetails.price"></nut-cell>
        <nut-cell title="退款金额"
          ><span slot="desc">
            <el-input
              v-model="orderDetails.refundAmount"
              type="number"
              class="input-box"
              @change="changeBackMoney"
            ></el-input> </span
        ></nut-cell>
      </div>
    </el-card>
    <div class="common-btn-box">
      <div class="common-btn-submit" @click="confimRefundHandler()">提交</div>
      <div class="common-btn-cancel" @click="orderDetailButton()">取消</div>
    </div>
  </div>
</template>
<script>
import { getOrderDetails, refundOrder } from "@/api/newApi";
import { Toast } from "vant";
import "vant/lib/toast/style/index";
export default {
  data() {
    return {
      ordernumber: "",
      token: "",
      orderDetails: {},
    };
  },
  mounted() {
    this.ordernumber = this.$route.query.ordernumber;
    this.token = window.localStorage.getItem("token");
    getOrderDetails({ orderNumber: this.ordernumber, token: this.token }).then(
      (res) => {
        this.orderDetails = res.data;
      }
    );

    console.log(this.ordernumber);
  },
  methods: {
    orderDetailButton() {
      this.$router.push({
        path: "/admin/order",
      });
    },
    changeBackMoney(e) {
      if (parseFloat(this.orderDetails.price) < Number(e)) {
        Toast("退款金额不能大于订单金额");
        this.orderDetails.refundAmount = parseFloat(this.orderDetails.price);
      }
    },
    confimRefundHandler() {
      if (this.orderDetails.refundAmount == "") {
        Toast("请输入退款金额");
        return;
      }
      if (
        this.orderDetails.refundAmount * 1 <= 0 ||
        this.orderDetails.refundAmount * 1 > this.orderDetails.price * 1
      ) {
        Toast("退款金额不能大于订单金额");
        return;
      }

      var formDataRefund = {
        orderId: this.orderDetails.id,
        refundAmount: this.orderDetails.refundAmount,
      };

      refundOrder(formDataRefund).then((res) => {
        console.log(res);
        if (res.message.code != 0) {
          Toast(res.message.message);
        } else {
          Toast("操作成功");
          this.refundShow = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.backMoneyMain {
  padding: 0.2667rem 0.4rem;
  ::v-deep .el-input-number{
    padding-bottom: 0.1333rem;
    .el-input__inner{
      height: 0.8rem;
      padding-left: 0;
      padding-right: 10px;
      text-align: right;
    }
    .el-input-number__decrease{
      display: none;
    }
    .el-input-number__increase{
      display: none;
    }
  }
  .input-box {
    ::v-deep .el-input__inner {
      text-align: right;
    }
  }
  .headerTitle {
    text-align: center;
    color: $titleColor;
  }

  ::v-deep .el-card__body {
    padding: 0rem !important;
    background-color: transparent;
  }

  ::v-deep .el-card__header {
    background-color: transparent;
    border-bottom: 1px solid transparent;
    margin: 0 0.2083rem;
  }

  ::v-deep .nut-cell {
    background-color: transparent !important;
    border-bottom: 1px solid transparent;

    .nut-cell-title {
      color: $liteTitleColor;
      font-size: 0.35rem;
    }

    .nut-cell-desc {
      color: #999;
      font-size: 0.35rem;
    }
  }

  ::v-deep .nut-cell-box,
  ::v-deep .nut-cell:last-of-type {
    background-image: none !important;
  }
  .orderDetailButton {
    width: 1.8933rem;
    height: 0.7467rem;
    line-height: 0.7467rem;
    text-align: center;
    font-size: 0.32rem;
    border: 1px solid $buttonColor;
    color: $buttonColor;
    border-radius: 0.3467rem;
    display: inline-block;
  }

  .buttons {
    ::v-deep .nut-cell-box {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;

      .nut-cell-left {
        margin-right: 0.4167rem;
      }
    }
  }
}
</style>
